import { render } from "./BetResult.vue?vue&type=template&id=1cb67830&scoped=true&ts=true"
import script from "./BetResult.vue?vue&type=script&lang=ts"
export * from "./BetResult.vue?vue&type=script&lang=ts"

import "./BetResult.vue?vue&type=style&index=0&id=1cb67830&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb67830"]])

export default __exports__